<template>
  <div class="friends-activation-modal">
    <fn-modal
      size="xl"
      full-screen-mobile
      :all-close="false"
      @close="$emit('close')"
    >
      <fn-friends-activation-options @submit="$emit('close')" />
    </fn-modal>
  </div>
</template>

<style lang="scss" scoped>
.friends-activation-modal {
  :deep(.modal) {
    overflow: hidden;

    &.modal--full-screen-mobile {
      @include bp(m, max) {
        overflow-y: scroll;
      }
    }

    .m-actions {
      border-bottom: none;
    }

    .m-content {
      height: 100%;
      margin-top: -72px;
    }
  }

  @include bp(l) {
    max-height: 417px;
  }
}
</style>
